module.exports = __webpack_public_path__ + "img/preview_saving_money.fcaa6bd4.png";